import cn from 'classnames';
import React, {ChangeEvent} from 'react';

interface IMultipleCheckbox extends React.HTMLProps<HTMLInputElement> {
  title?: string;
  id?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  isRotate?: boolean;
  customClass?: string;
  titleClass?: string;
  showSvg?: boolean;
}

const CustomCheckbox = ({
  title,
  id,
  onChange,
  isRotate,
  customClass,
  titleClass,
  showSvg,
  ...props
}: IMultipleCheckbox) => {
  return (
    <label
      className={cn('flex items-center cursor-pointer', customClass, {
        'opacity-40 pointer-events-none': props.disabled,
      })}
    >
      <input
        type="checkbox"
        onChange={onChange}
        checked={props.checked}
        className="hidden"
      />

      <span
        className={cn(
          'w-4 h-4 flex items-center justify-center border-[1px] rounded-[5px] transition-colors duration-200 bg-white',
          {
            'border-gray-700': !props.checked,
            'border-green-main': props.checked,
          },
        )}
      >
        {props.checked && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#669F2A"
            className="w-3 h-3"
          >
            <path d="M5 12.5l3.5 3.5L19 6.5l1.5 1.5-12 12-4.5-4.5L5 12.5z" />
          </svg>
        )}
      </span>

      <span className={cn('mr-1 text-sm text-gray-900', titleClass)}>
        {title}
      </span>
    </label>
  );
};

export default CustomCheckbox;
